<template>
  <div class="wrap">
    <span class="uslogin0" style="color: black"><router-link style="color:#000000;" to="/language">{{$t('lange.uslogin0')}}</router-link></span>
    <div class="alcenter"></div>
    <div class="container">
      <div class="loginTitle">{{$t('lange.loginTitle')}}</div>
      <div class="mu-form mu-demo-form">
        <div class="mu-form-item mu-form-item__has-label">
          <div class="mu-form-item-content">
            <div data-v-7c867c24="" class="mu-input">
              <div class="img">
                <img src="../assets/images/login-icon1.png" alt="" />
              </div>
              <div class="mu-text-field mu-input-content">
                <input
                  class="mu-text-field-input"
                  :placeholder="$t('lange.uslogin1')"
                  type="text"
                  v-model="email"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="mu-form-item mu-form-item__has-label mg">
          <div class="mu-form-item-content">
            <div data-v-7c867c24="" class="mu-input">
              <div class="img">
                <img src="../assets/images/login-icon2.png" alt="" />
              </div>
              <div class="mu-text-field mu-input-content">
                <input
                  class="mu-text-field-input"
                  :placeholder="$t('lange.uslogin2')"
                  :type="passwordType"
                  v-model="password"
                />
                <div @click="togglePassword()">
                    <img
                    v-if="passwordType == 'password' "
                  class="ant"
                  src="../assets/images/yincangmima.png"
                  alt=""
                />
                <img
                v-else
                  class="ant"
                  src="../assets/images/xianshimima.png"
                  alt=""
                />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="loginLogin" @click="getLogin()">{{$t('lange.loginLogin')}}</div>
        <div class="bottom-text">
            <div> <router-link to="/register">{{$t('lange.registerTitle')}}</router-link></div>
            <div @click="goToExternalLink()">{{$t('lange.fexCenterMenuService')}}</div>
        </div>
      </div>
    </div>
        <!-- 提示窗 -->
    <div class="alert alert-success" v-if="alertStuas">
      <div class="text">{{ msgtitle }}</div>
      <div class="btn-close" @click="alertStuas = false">
        <img src="../assets/images/guanbi.png" alt="" />
      </div>
    </div>
    <div class="alert alert-danger" v-if="alertStuas2">
      <div class="text">{{ msgtitle }}</div>
      <div class="btn-close" @click="alertStuas2 = false">
        <img src="../assets/images/guanbi.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { login ,info} from "../request/api";
export default {
  data() {
    return {
        alertStuas:false,
        alertStuas2:false,
        passwordType:'password',
        email:'',
        password:'',
        msgtitle:'',
        isClicked: false,
    };
  },
  methods: {
        goToExternalLink() {
      const externalUrl = this.$store.state.service;
      window.location.href = externalUrl;
       window.open(externalUrl, _blank)
    },
    getLogin(){
      if (this.isClicked) {
        return
      }
      this.isClicked = true
      let data = {
        email:this.email,
        password:this.password
      }
      login(data).then((res) =>{
        setTimeout(() => {
        this.isClicked = false
      }, 1500) // 1秒后重置标记
         if (res.code == 0) {
          this.msgtitle = res.msg;
          this.alertStuas = true;
          setTimeout(() => {
            this.alertStuas = false;
          }, 2000);
            localStorage.setItem('token',res.data.token)
            info().then((res) =>{
              console.log(res)
              localStorage.setItem('info',JSON.stringify(res))
              this.$store.commit("Updateinfo", res);
            })
           this.$router.push({ path: "/", query: {} });
           this.$store.commit("Uppopstatus", 1);
        } else {
          this.msgtitle = res.msg;
          this.alertStuas2 = true;
          setTimeout(() => {
            this.alertStuas2 = false;
          }, 3000);
        }
      })
    },
    togglePassword() {
        this.passwordType = this.passwordType === "password" ? "text" : "password";
        // console.log(this.passwordType)
    },
  },
};
</script>
<style lang="less" scope>
.wrap {
  height: 100%;
  text-align: left;
  padding: 40px;
  background: #fafef8;
  .uslogin0 {
    height: 88px;
    line-height: 88px;
    font-size: 24px;
    display: flex;
    justify-content: end;
    margin: auto;
    color: black;
  }
  .alcenter {
    height: 100px;
  }
  .container {
    .loginTitle {
      line-height: 100px;
      margin: 0px 0px 60px;
      text-align: center;
      font-size: 56px;
      font-weight: 700;
    }
    .mu-form-item {
      display: flex;
      flex-direction: column;
      min-height: auto;
      color: rgba(0, 0, 0, 0.54);
      // margin-bottom: 32px;
      padding-bottom: 24px;
      position: relative;
    }
    .mu-form-item-content {
      min-height: 64px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      border-radius: 60px;
      border: solid 2px #e6eaed;
      .img {
        width: 50px;
        margin: 0 20px;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .mu-input {
        padding: 0;
        margin-bottom: 0;
        width: 100%;
        display: flex;
        align-items: center;
      }
      .mu-text-field {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        font-size: 28px;
      }
      .mu-text-field-input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        outline: none;
        border: none;
        background: none;
        border-radius: 0 0 0 0;
        box-shadow: none;
        display: block;
        padding: 0;
        margin: 0;
        width: 100%;
        height: 32px;
        font-style: inherit;
        font-variant: inherit;
        font-weight: inherit;
        font-stretch: inherit;
        font-size: inherit;
        color: rgba(0, 0, 0, 0.87);
        font-family: inherit;
        position: relative;
        flex: 1;
        height: 80px;
      }
    }
  }
  .ant {
    width: 40px;
    height: 40px;
    display: block;
    padding: 0 12px;
  }
  .mg{
          margin-bottom: 60px;
  }
  .loginLogin{
      background-color: #2196f3;
          color: #fff;
          font-size: 32px;
          height: 80px;
          line-height: 80px;
    border-radius: 40px;
    text-align: center;
  }
  .bottom-text{
      margin: 50px 0 32px 0;
      display: flex;
      font-size: 24px;
      color: rgba(0, 0, 0, .54);
      div{
          width: 50%;
          line-height: 2;
      }
      div:nth-child(2){
          text-align: right;
      }
  }
}
.night{
  .wrap{
    background: #0b1622;
    a{
      color: #fff !important;
    }
    .loginTitle{
      color: #1881d2;
    }
     .mu-text-field-input{
       color: #fff !important;
     }
  }
}
</style>